import { useNavigate } from 'react-router-dom';
import prepareTranslate from '@/helpers/dictionary';
import { Button } from '@mantine/core';
import routes from '@/routes';
import PropTypes from 'prop-types';
import { IconEdit } from '@tabler/icons-react';
import SectionView from '@/components/SectionView';
import { useEffect, useState } from 'react';
import { formatDateToString } from '@/helpers/string';
import userMutations from '@/api/mutitations/user';
import Modal from '../DetailsModal';

const Userview = (props) => {
  const {
    opened,
    close,
    id,
    editUser,
  } = props;

  const navigate = useNavigate();
  const [userData, setUserData] = useState('');
  const t = prepareTranslate();
  const { useGetOne } = userMutations;
  const getOne = useGetOne();

  useEffect(() => {
    if (opened && id) {
      const fetchUser = async () => {
        try {
          const result = await getOne.mutateAsync({ id });
          setUserData(result.user);
        } catch (error) {
          navigate(routes.users.path);
        }
      };

      fetchUser();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opened, id]);

  const {
    firstName,
    lastName,
    role,
    email,
    phone,
    isBlocked,
    lastLoginAttempt,
    loginAttempts,
    passwordLastChanged,
    updatedAt,
  } = userData;

  const fullName = `${firstName} ${lastName}`;

  const detailsLines = [
    {
      title: t('pages.userview.labels.firstname'),
      value: firstName,
    },
    {
      title: t('pages.userview.labels.lastname'),
      value: lastName,
    },
    {
      title: t('pages.userview.labels.role'),
      value: role,
      transforms: [
        {
          func: 'badge',
          params: {
            rules: [
              { byValue: 'administrator', color: 'blue' },
              { byValue: 'superadmin', color: 'violet' },
            ],
          },
        },
      ],
    },
  ];

  const contactLines = [
    {
      title: t('pages.userview.labels.email'),
      value: email,
      transforms: ['email'],
    },
    {
      title: t('pages.userview.labels.phone'),
      value: phone,
      transforms: ['phone'],
    },
  ];

  const infoLines = [
    {
      title: t('pages.userview.labels.block'),
      value: isBlocked,
      transforms: [
        { func: 'yesno', params: { yes: { title: 'משתמש חסום', color: 'red' }, no: { title: 'משתמש לא חסום', color: 'blue' } } },
      ],
    },
    {
      title: t('pages.userview.labels.lastLoginAttempt'),
      value: lastLoginAttempt,
      transforms: ['timeago'],
    },
    {
      title: t('pages.userview.labels.loginAttempts'),
      value: loginAttempts,
    },
    {
      title: t('pages.userview.labels.passwordLastChanged'),
      value: passwordLastChanged,
      transforms: [
        { func: 'date' },
      ],
    },
  ];

  const handleUpdateClick = () => {
    editUser();
    close();
  };
  if (!id) return null;
  return (
      <>
          <Modal
              opened = {opened}
              label={t('pages.userview.title', [fullName])}
              sublabel={t('pages.userview.subtitle', [formatDateToString(updatedAt, true)])}
              actions={<Button onClick={handleUpdateClick} leftSection={<IconEdit />}>{t('pages.userview.action')}</Button>}
              close = {close}
          >
          <SectionView lines={detailsLines} />
          <SectionView lines={contactLines} />
          <SectionView lines={infoLines} />

          </Modal>
    </>
  );
};

Userview.propTypes = {
  opened: PropTypes.bool,
  close: PropTypes.func,
  id: PropTypes.string,
  editUser: PropTypes.func,
};

export default Userview;
